<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.875 5.12431L8.5 2.5L11.125 5.12431" [attr.stroke]="stroke" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.5 9.50011V2.50195" [attr.stroke]="stroke" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    <path
        d="M14 9.5V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H3.5C3.36739 13.5 3.24021 13.4473 3.14645 13.3536C3.05268 13.2598 3 13.1326 3 13V9.5"
        [attr.stroke]="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>